import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import HomepageV2 from 'components/HomepageV2';
import HomepageV3 from 'components/HomepageV3';

const Homepage = ({
  homepageData,
  multiTouchCampaignAnalyticsMetadata,
  isModalOpen,
  isMiniNavigationExperimentLoading,
  isMultiTouchCampaignLoading,
  isConsentConfirmationModalOpen,
  miniNavigationPlacementExperimentAnalyticsData,
  consentDecision,
  openModal,
  closeModal,
  signUpForNewsletter,
  trackModuleEvent,
}) => {
  const { dyDecisionId, dyVariationId } = multiTouchCampaignAnalyticsMetadata || {};

  const handleTrackModuleEvent = useCallback(
    ({
      moduleType,
      moduleName,
      modulePosition,
      carouselCategoryName,
      carouselCardPosition,
      carouselCardName,
      imageName,
      linkCTAName,
      linkDestination,
    }) => {
      trackModuleEvent({
        moduleType,
        moduleName,
        modulePosition,
        carouselCategoryName,
        carouselCardPosition,
        carouselCardName,
        imageName,
        linkCTAName,
        linkDestination,
        dyDecisionId,
        dyVariationId,
      });
    },
    [dyDecisionId, dyVariationId, trackModuleEvent]
  );

  if (homepageData._contentType === 'homepageV3') {
    return (
      <HomepageV3
        homepageData={homepageData}
        isModalOpen={isModalOpen}
        isMiniNavigationExperimentLoading={isMiniNavigationExperimentLoading}
        miniNavigationPlacementExperimentAnalyticsData={
          miniNavigationPlacementExperimentAnalyticsData
        }
        isMultiTouchCampaignLoading={isMultiTouchCampaignLoading}
        isConsentConfirmationModalOpen={isConsentConfirmationModalOpen}
        openModal={openModal}
        closeModal={closeModal}
        trackModuleEvent={handleTrackModuleEvent}
        signUpForNewsletter={signUpForNewsletter}
        consentDecision={consentDecision}
      />
    );
  }

  return (
    <HomepageV2
      homepageData={homepageData}
      isModalOpen={isModalOpen}
      openModal={openModal}
      closeModal={closeModal}
      trackModuleEvent={trackModuleEvent}
      signUpForNewsletter={signUpForNewsletter}
    />
  );
};

Homepage.propTypes = {
  closeModal: PropTypes.func,
  homepageData: PropTypes.object,
  isModalOpen: PropTypes.bool,
  isMiniNavigationExperimentLoading: PropTypes.bool,
  isConsentConfirmationModalOpen: PropTypes.bool,
  miniNavigationPlacementExperimentAnalyticsData: PropTypes.shape({
    campaignId: PropTypes.string,
    variationId: PropTypes.number,
  }),
  isMultiTouchCampaignLoading: PropTypes.bool,
  multiTouchCampaignAnalyticsMetadata: PropTypes.shape({}),
  consentDecision: PropTypes.string,
  openModal: PropTypes.func,
  signUpForNewsletter: PropTypes.func,
  trackModuleEvent: PropTypes.func,
};

Homepage.defaultProps = {
  homepageData: {},
  isModalOpen: false,
  isMultiTouchCampaignLoading: false,
};

export default Homepage;
